import { render, staticRenderFns } from "./rightCent.vue?vue&type=template&id=2b5477ed&scoped=true"
import script from "./rightCent.vue?vue&type=script&lang=js"
export * from "./rightCent.vue?vue&type=script&lang=js"
import style0 from "./rightCent.vue?vue&type=style&index=0&id=2b5477ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5477ed",
  null
  
)

export default component.exports